import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({

    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 5,
            retry: 0,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            gcTime: 1000 * 60 * 10,


        },


    },
});
export default queryClient;
